var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leaders-top"},[_c('div',[_vm._l((_vm.categories),function(shelfBook,index){return _c('div',{key:index},[_c('LeadersBook',{attrs:{"bookList":shelfBook,"indexList":index},on:{"handleClick":_vm.handleClickBook}})],1)}),_vm._v(" "),_c('span',{staticClass:"shelf-bar"})],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a70051e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/fanClub/leaders/LeadersTop.vue
// module id = null
// module chunks = 